import { useCallback, useState } from "react"
import { ActionModal } from "../modals/ActionModal";
import { useTranslation } from "react-i18next";
import { Portal } from "react-portal";

export interface ConfirmActionProps {
    children: (open: () => void, close: () => void, isOpen: boolean) => React.ReactNode;
    action: () => Promise<void>;
    title: string;
    confirmText?: string;
    prompt?: React.ReactNode|string;
}
export const ConfirmAction = ({
    children,
    action,
    title,
    confirmText,
    prompt
}: ConfirmActionProps) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    return (
        <>
            {children(open, close, isOpen)}
            <ActionModal
                open={isOpen}
                canSave={true}
                action={action||(() => {})}
                onClose={() => setIsOpen(false)}
                title={title || t('confirm')}
                confirmText={confirmText || t('confirm')}
            >
                {prompt}
            </ActionModal>
        </>
    )
}